<template>
  <v-alert dense type="error" tile>
    <slot />
  </v-alert>
</template>

<script>
export default {
  name: 'TrainDeviationError'
}
</script>
